module.exports = __webpack_public_path__ + "static/img/xyqp-02.4a113493.jpg";